// 应用配置文件
// 从环境变量中获取配置信息

// API配置
const apiConfig = {
  baseURL: process.env.API_BASE_URL || '/api',
  timeout: 900000
}

// 应用配置
const appConfig = {
  title: 'PGA Tour',
  version: '1.0.0'
}

export { apiConfig, appConfig }



// WEBPACK FOOTER //
// ./src/config/index.js